import styled from '@emotion/styled';
import { vars } from '@teamsparta/stack-tokens';

import { LARGE_TABLET } from '@/styles/themes';

export const PostDetailContainer = styled.div`
  width: 100%;
  border-radius: 12px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 16px;

  ${LARGE_TABLET} {
    background-color: ${vars.neutral[95]};
    gap: 30px;
    padding: 30px;
  }
`;

export const ExtendedDivider = styled.div`
  margin: 0 -16px;
`;
